import {
    VTextField,
    VSelect,
    VSwitch,
    VTextarea,
    VAutocomplete
  } from 'vuetify/components';
  
  import FileUploader from '@/components/form/FileUploader.vue';
  import DynamicJsonField from '@/components/form/DynamicJsonField.vue';
  import type { FormField } from '@/types/form';
  
  export const CREATE_FORM: FormField[] = [
    {
      value: 'featured_image',
      label: 'Imagen',
      component: FileUploader,
      module: 'posters',
      col: 10,
      required: false,
    },
    { value: 'is_illuminated', 
      label: 'Iluminación', 
      component: VSwitch, 
      required: false,
      col: 2,
      transform: (v: boolean) => ({ is_illuminated: v ? 1 : 0 }), 
    },
    {
      value: 'sku',
      label: 'SKU',
      component: VTextField,
      col: 6,
      required: true,
    },
    {
      value: 'address',
      label: 'Calle(s)',
      component: VTextField,
      col: 6,
      required: true,
    },
    {
      value: 'neighborhood',
      label: 'Colonia',
      component: VTextField,
      col: 6,
      required: false,
    },
    {
      value: 'zip',
      label: 'Código Postal',
      component: VTextField,
      required: false,
      col: 6,
    },
    { value: 'state', 
      label: 'Estado', 
      component: VSelect,
      required: false, 
      col: 6, 
      mdcol:12, 
      fetchOptions: 'searchStates', 
      itemText: 'state', 
      itemValue: 'state',
    },
    {
      value: 'city',
      label: 'Ciudad',
      component: VSelect,
      required: false,
      col: 6,
      fetchOptions: 'searchCities',
      itemText: 'city',
      itemValue: 'city',
      dependsOn: 'state',
      dependsBehavior: 'disabled',
      dependsCondition: { value: null, condition: 'diferent' },
      fetchParams: (form: any) => ({
        state: form.state,
      }),
    },
    {
      value: 'longitude',
      label: 'Longitud',
      component: VTextField,
      required: false,
      col: 6,
    },
    {
      value: 'latitude',
      label: 'Latitud',
      component: VTextField,
      required: false,
      col: 6,
    },
    /*{
      value: 'width',
      label: 'Medida (Ancho)',
      component: VTextField,
      required: false,
      col: 6,
    },
    {
      value: 'height',
      label: 'Medida (Alto)',
      component: VTextField,
      required: false,
      col: 6,
    },*/
    {
      value: 'measures',
      label: 'Medida',
      component: VTextField,
      required: false,
      col: 6,
    },
    { 
      value: 'structure', 
      label: 'Estructura', 
      component: VSelect, 
      options: ['Pantalla', 'Unipolar', 'Cartelera', 'Terreno'], 
      required: false,
      col: 6 
    },
    
    {
      value: 'product_id',
      required: true,
    },
    {
      value: 'medium',
      required: true,
    },
    {
      value: 'references',
      label: 'Referencias',
      component: VTextarea,
      required: false,
      col: 12 
    },
    {
      value: 'prices',
      label: 'Lista de Precios',
      isJsonArray: true,
      component: DynamicJsonField,
      col: 12,
      transform: (val: any[]) => {
        return (val || []).map((type: any) => ({
          amount: type.amount,
          client_type_id: type.client_type_id || (typeof type.client_type === 'object' ? type.client_type.id : type.client_type),
          product_type: "App\\Models\\Product"
        }));
      },
      children: [
        {
          value: 'client_type',
          label: 'Tipo de Cliente',
          searchValue: 'name',
          component: VAutocomplete,
          fetchOptions: 'getClientTypes',
          itemText: 'name',
          itemValue: (item: any) => item,
          required: true,
          col: 6,
          transform: (value: any) => ({
            client_type_id: value?.id,
          })
        },
        {
          value: 'amount',
          label: 'Precio',
          component: VTextField,
          required: true,
          type: 'number',
          col: 6,
          prefix: '$'
        }
      ]
    }
    
  ];
  
  export const EDIT_FORM: FormField[] = [...CREATE_FORM.map(field => {
  if (field.value == 'is_illuminated'){
    return {
      ...field,
      // cuando hidratas el form desde el item del backend:
      parse: (_: any, item: any) => Boolean(Number(item?.is_illuminated)),
      transform: (v: boolean) => ({ is_illuminated: v ? 1 : 0 }),
    }
  }
  return field;
})];
  
  export const HEADERS = [
    { title: 'SKU', value: 'attributes.sku', format: 'text', sortable: false },
    { title: 'Dirección', value: 'attributes.address', format: 'text', sortable: false },
  ];
  
  export const DYNAMIC_COLUMNS = {
    field: 'attributes.prices',
    key: 'client_type.name',
    label: (name: string) => `Precio ${name}`,
    value: 'amount',
    format: 'currency',
  };
  
  export const DEFAULT_HEADER_ORDER = [
    'attributes.sku',
    'attributes.address'
  ];
  
  export const FILTERS = [
    
  ];
  
  export const ROW_ACTIONS = [
    { label: 'Editar', onClick: '__edit', permission: 'posters.update' },
    { label: 'Eliminar', onClick: '__delete', permission: 'posters.delete' },
  ];
  